import { getState } from './storage';
import * as types from './store/mutation-types'

export default function (store) {
  if (store.initialized) {
    return Promise.resolve();
  }
  console.log('loadState startup')
  return getState()
    .then(state => store.commit(types.LOAD_FROM_CACHE, state));
}